/** Angular */
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ScrollUtilsService {

	scrollY = new BehaviorSubject(0);
  	scrollY$ = this.scrollY.asObservable();

	private lastScrollTop = 0;

	private isScrollDown = new BehaviorSubject(false);
	isScrollDown$ = this.isScrollDown.asObservable();

	constructor() {}
  
	updateScrollY(value: number): void {
		this.scrollY.next(value);
		this.isScrollDown.next(value > this.lastScrollTop);
		this.lastScrollTop = value <= 0 ? 0 : value;
	}
}
